import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Send, UserCheck } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { InviteFlow } from "@/components/red/InviteFlow";
import { MemberAvatar } from "@/components/red/MemberAvatar";

const PhoneMatch = ({ m, onConnect }) => (
  <div data-testid="contact-in-conecta" className="rounded-xl border c-line p-3 flex items-center gap-3">
    <MemberAvatar m={m} size="w-10 h-10 text-sm" />
    <div className="flex-1 min-w-0">
      <p className="text-sm font-semibold">Este contacto ya está en CONECTA{m.relacion === "ninguna" ? ", ¿conectar?" : ""}</p>
      <Link to={`/conecta/u/${m.id}`} data-testid="contact-in-conecta-profile" className="text-xs c-accent font-semibold">{m.nombre_publico}</Link>
    </div>
    {m.relacion === "ninguna" && <button data-testid="contact-in-conecta-connect" onClick={onConnect} className="c-btn-primary px-3 py-2 text-xs">Conectar</button>}
    {m.relacion === "activa" && <span className="text-xs c-text-2 flex items-center gap-1"><UserCheck className="w-4 h-4" /> Conectados</span>}
    {m.relacion === "pendiente_enviada" && <span className="text-xs c-muted">Solicitud enviada</span>}
  </div>
);

export const ContactInviteBlock = ({ c }) => {
  const [match, setMatch] = useState(null);
  const [inviting, setInviting] = useState(false);
  useEffect(() => { api.get(`/red/contactos/${c.id}/coincidencia`).then((r) => setMatch(r.data.miembro)).catch(() => {}); }, [c.id, c.telefono_hash]);
  const connect = async () => {
    try {
      await api.post("/red/conexiones", { user_id: match.id, origen: "telefono" });
      setMatch((m) => ({ ...m, relacion: "pendiente_enviada" }));
      toast.success("Solicitud de conexión enviada");
    } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <div className="pt-3 space-y-2">
      {match ? <PhoneMatch m={match} onConnect={connect} /> : (
        <button data-testid="contact-invite-btn" onClick={() => setInviting(true)} className="w-full py-2.5 rounded-xl border c-line text-sm font-semibold flex items-center justify-center gap-2">
          <Send className="w-4 h-4 c-accent" /> Invitar a CONECTA
        </button>
      )}
      <InviteFlow contacts={[c]} open={inviting} onOpenChange={setInviting} />
    </div>
  );
};
